import React, { useContext, useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { FormControl, FormLabel, FormControlLabel } from "@mui/material";
import { DropDownListComponent } from "@syncfusion/ej2-react-dropdowns";
import { RadioButtonComponent } from "@syncfusion/ej2-react-buttons";
import { CredsContext } from "./Contexts";
import Tools from "./JNSTools";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import SettingsProjectsFinishDate from "./SettingsProjectsFinishDate";
import SettingsProjectsETCCalc from "./SettingsProjectETCCalc";
import SettingsProjectsStatusEmailConfiguration from "./SettingsProjectsStatusEmailConfiguration";
import Checkbox from "@mui/material/Checkbox";
import { grey } from "@mui/material/colors";
import "./styles/Settings.css";

function SettingsProjects(props) {
  const creds = useContext(CredsContext).creds;
  const projectObject = JSON.parse(sessionStorage.getItem("projectObject"));
  const [wait, setWait] = useState(false);
  const [showBilling, setShowBilling] = useState(
    projectObject.oada_project_show_billing__c == 1 ? true : false,
  );
  const [showRAIDActions, setShowRAIDActions] = useState(
    projectObject.oada_project_raid_assumptions__c == 1 ? true : false,
  );
  const authString = Tools.getXmlBodyAuthString(creds);
  const urlString = Tools.getInstanceUrl(creds);

  const handleRAIDActions = () => {
    const newRAIDActions = !showRAIDActions;
    projectObject.oada_project_raid_assumptions__c = newRAIDActions ? 1 : null;
    sessionStorage.setItem("projectObject", JSON.stringify(projectObject));
    const modifyString =
      authString +
      '<Modify type="Project" enable_custom="1"><Project><id>' +
      projectObject.id +
      "</id><oada_project_raid_assumptions__c>" +
      projectObject.oada_project_raid_assumptions__c +
      "</oada_project_raid_assumptions__c></Project></Modify></request>";
    Tools.fetchPost(modifyString, urlString);
    if (projectObject.oada_project_raid_assumptions__c) {
      sessionStorage.setItem("selectedRaidSubtab", "Assumptions");
    } else {
      sessionStorage.setItem("selectedRaidSubtab", "Actions");
    }
    setShowRAIDActions(newRAIDActions);
  };

  return (
    <Box>
      <Backdrop
        sx={{ color: "#fff", zIndex: 10 }} //, zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={wait}
        //onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <FormControl>
        <FormLabel>
          <div className="settingsGroupTitle">Projects Settings</div>
        </FormLabel>
      </FormControl>
      <hr></hr>
      <SettingsProjectsFinishDate waitHandler={setWait} />
      <hr></hr>
      <SettingsProjectsETCCalc projectObject={projectObject} />
      <hr></hr>
      <SettingsProjectsStatusEmailConfiguration />
      <hr></hr>
      <FormControl>
        <FormControlLabel
          checked={showRAIDActions}
          onClick={handleRAIDActions}
          control={
            <Checkbox
              size="small"
              sx={{
                marginLeft: "20px",
                color: grey[50],
                "&.Mui-checked": {
                  color: grey[50],
                },
              }}
            />
          }
          label="RAID:  Use 'Assumptions' instead of 'Actions'"
          className="settingsRadioButtonLabel"
        />
      </FormControl>
    </Box>
  );
}

export default SettingsProjects;

SettingsProjects.propTypes = {
  handleSettingsChange: PropTypes.func,
};

/*
TODO:  Fix gantt enabled feature OR remove it

<FormControlLabel
          checked={ganttEnabled}
          onClick={handleGanttEnabledClick}
          control={
            <Checkbox
              size="small"
              sx={{
                marginLeft: "20px",
                color: grey[50],
                "&.Mui-checked": {
                  color: grey[50],
                },
              }}
            />
          }
          label="Gantt chart tab enabled (takes effect on next login)"
          className="settingsRadioButtonLabel"
        />
        
        
        
                <FormControlLabel
          checked={showBilling}
          onClick={handleShowBillingClick}
          control={
            <Checkbox
              size="small"
              sx={{
                marginLeft: "20px",
                color: grey[50],
                "&.Mui-checked": {
                  color: grey[50],
                },
              }}
            />
          }
          label="Show Billing Data on Dashboard"
          className="settingsRadioButtonLabel"
        />
        */
